import { FadeUp, MaskedLine, Overline } from "@/components/Reveal";

export default function PageHero({ overline, title, italic, children, testid }) {
  return (
    <section className="border-b border-linen bg-beige/50 pb-14 pt-32 sm:pt-36">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <FadeUp>
          <Overline>{overline}</Overline>
        </FadeUp>
        <h1 data-testid={testid} className="mt-4 font-serif text-4xl leading-[1.08] tracking-tight text-olive sm:text-5xl lg:text-6xl">
          <MaskedLine delay={0.1}>{title}</MaskedLine>
          {italic && (
            <MaskedLine delay={0.22} className="italic text-burgundy">
              {italic}
            </MaskedLine>
          )}
        </h1>
        {children && (
          <FadeUp delay={0.35} className="mt-6 max-w-2xl text-base leading-relaxed text-moss sm:text-lg">
            {children}
          </FadeUp>
        )}
      </div>
    </section>
  );
}
